module.exports = __webpack_public_path__ + "img/nav.555df8b0.gif";